import TableLoadingContentMobile from "./TableLoadingContentMobile"

function LoadingRow({ columns }) {
    return (
        <tr className="h-[68px] border-b border-gray-100 dark:border-gray-800">
            {[...Array(columns)].map((_, i) => (
                <td key={i} className="p-4">
                    <div className="shimmer-bar" />
                </td>
            ))}
        </tr>
    )
}

export default function DashboardTable({ tableData, isLoading }) {

    const { headLabels, list, data, actions, mobileList } = tableData
    const columnCount = headLabels.length + (actions ? 1 : 0)

    const tHeadStyle = {
        padding: '10px 20px',
        fontSize: '12px',
        fontWeight: '500',
        color: '#595959'
    }

    return (
        <div className="overflow-hidden w-full">
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-[14px] text-[#595959] dark:text-gray-300">
                    <thead>
                        <tr className="bg-[#F9FAFB] dark:bg-gray-900 border-b border-[#eee] dark:border-gray-700">
                            {headLabels.map((label, index) => {
                                const isObject = typeof label === 'object';
                                const text = isObject ? label.label : label;
                                const className = isObject ? label.className : '';
                                return (
                                    <td key={index} style={tHeadStyle} className={`dark:text-gray-400 whitespace-nowrap ${className}`}>
                                        {text}
                                    </td>
                                );
                            })}
                            {actions && <td style={tHeadStyle} className="text-center dark:text-gray-400">Actions</td>}
                        </tr>
                    </thead>
                    {isLoading ? (
                        <tbody className="dark:text-gray-100">
                            {[...Array(10)].map((_, i) => (
                                <LoadingRow key={i} columns={columnCount} />
                            ))}
                        </tbody>
                    ) : data && (
                        <tbody className="[&>*:nth-child(even)]:bg-white dark:[&>*:nth-child(even)]:bg-gray-900/50 dark:text-gray-100">
                            {list}
                        </tbody>
                    )}
                </table>
            </div>

            {/* Mobile Card View */}
            <div className="md:hidden overflow-hidden">
                {isLoading ? (
                    <TableLoadingContentMobile />
                ) : (
                    <div className="flex flex-col gap-3 p-3">
                        {mobileList || list}
                    </div>
                )}
            </div>
        </div>
    )
}